export default __webpack_public_path__ + "static/media/validasi-kepala-purchasing.45b22ec6.png";